import React, { useState } from 'react';
import { Avatar, Chip, Typography, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import { refactorPriceRange } from '../../utils/_helpers';
import { BasePopup, ConfirmButton, PopupSubtitle } from './BasePopup.jsx';
import { SelectApproverAutocomplete } from './SelectApproverAutocomplete.jsx';
import { SelectOrderCategoryAutocomplete } from './SelectOrderCategoryAutocomplete.jsx';
import { SelectAgentAutocomplete } from './SelectAgentAutocomplete.jsx';

export const EditDeleteDialog = ({
    open,
    title,
    dialogType,
    userDetails,
    costCenterDescription,
    userIndex,
    handleCloseDialog,
    context,
    handleDeleteApprover,
    handleEditApprover,
    avatarColor,
}) => {
    const getOptions = context.get('get options');
    const [selectedOrderCategory, setSelectedOrderCategory] = useState(null);
    const [selectedApprover, setSelectedApprover] = useState(null);

    const typeOptions = [
        { label: 'User', value: 'US' },
        { label: 'Position', value: 'S' },
    ];
    const [type, setType] = useState(typeOptions[0].value);

    const handleDeleteApproverAndClose = (userDetails) => (event) => {
        handleCloseDialog();
        handleDeleteApprover(userDetails.AgentId, userDetails.OrderCategory);
    };

    const handleEditApproverAndClose = (userDetails, newApprover, newOrderCategory) => (event) => {
        handleCloseDialog();
        handleEditApprover(userDetails.AgentId, userDetails.OrderCategory, newApprover, newOrderCategory?.Auftyp, type);
    };

    const operation = context.get('Operation');

    if (open) {
        const contentPart1 = (
            <div>
                <PopupSubtitle subtitle={title} />
                <Chip
                    color="primary"
                    sx={{ marginBottom: '1vh' }}
                    label={`${
                        userDetails.CostElementId ? userDetails.CostElementId : userDetails.CostCenterId
                    } - ${costCenterDescription}`}
                />
                <PopupSubtitle subtitle="Band" />
                <Chip
                    color="primary"
                    label={`${refactorPriceRange(userDetails.PriceRange)} (${userDetails.RelGroup}/${
                        userDetails.RelCode
                    })`}
                    sx={{ marginBottom: '1vh' }}
                />
            </div>
        );

        const contentPart2 = (
            <div>
                <PopupSubtitle subtitle="Current Approver" />
                <div key={userIndex} className={'user-list'}>
                    <Avatar sx={{ backgroundColor: avatarColor, marginRight: '1rem' }}>
                        {userDetails.Uname !== ''
                            ? userDetails.Uname.match(/\b(\w)/g)
                                  .join('')
                                  .toUpperCase()
                            : ''}
                    </Avatar>
                    <div className={'user-name'}>{userDetails.Uname ? userDetails.Uname : ''}</div>
                </div>
            </div>
        );

        if (dialogType === 'edit') {
            return (
                <BasePopup
                    title={`${'Change Approver' + (operation !== 'PO' ? '/ Order Category' : '')}`}
                    content={
                        <div>
                            {contentPart1}
                            {operation !== 'PO' && (
                                <>
                                    <PopupSubtitle subtitle="Order Category" />
                                    <SelectOrderCategoryAutocomplete
                                        context={context}
                                        selectedOrderCategory={selectedOrderCategory}
                                        setSelectedOrderCategory={setSelectedOrderCategory}
                                    />
                                </>
                            )}
                            {contentPart2}

                            {/* <PopupSubtitle subtitle="New Approver" />
                            <SelectApproverAutocomplete
                                context={context}
                                selectedApprover={selectedApprover}
                                setSelectedApprover={setSelectedApprover}
                            /> */}

                            <div>
                                <div
                                    className="edit-agent-responsibility-form"
                                    style={{ display: 'flex', flexDirection: 'column' }}
                                >
                                    <div>
                                        <Typography variant="caption">Type</Typography>
                                        <RadioGroup
                                            row
                                            name="row-radio-buttons-group"
                                            value={type ?? typeOptions[0].value}
                                            onChange={(event, value) => {
                                                setType(value ?? '');
                                                setSelectedApprover(null);
                                            }}
                                        >
                                            {typeOptions.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </div>
                                    {type === 'US' ? (
                                        <div>
                                            {!selectedApprover && <Typography variant="caption">New User</Typography>}
                                            <SelectApproverAutocomplete
                                                context={context}
                                                selectedApprover={selectedApprover}
                                                setSelectedApprover={setSelectedApprover}
                                            />
                                        </div>
                                    ) : null}
                                    {type === 'S' ? (
                                        <div>
                                            {!selectedApprover && (
                                                <Typography variant="caption">New Position</Typography>
                                            )}
                                            <SelectAgentAutocomplete
                                                context={context}
                                                getOptions={getOptions}
                                                selectedApprover={selectedApprover}
                                                setSelectedApprover={setSelectedApprover}
                                                path={'PositionIdSet'}
                                                filter={(value) => `IdNo eq '01' and SearchTerm eq '${value}'`}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    }
                    button={
                        <ConfirmButton
                            text="Send Request"
                            onClick={handleEditApproverAndClose(userDetails, selectedApprover, selectedOrderCategory)}
                        />
                    }
                    handleCloseDialog={handleCloseDialog}
                />
            );
        } else if (dialogType === 'delete') {
            return (
                <BasePopup
                    title="Remove Approver"
                    content={
                        <div>
                            {contentPart1}
                            <PopupSubtitle subtitle="Order Category" />
                            <Chip
                                color="primary"
                                label={`${userDetails.OrderCategory}`} // add order cat name?
                                icon={<CachedIcon />}
                                sx={{ marginBottom: '1vh' }}
                            />
                            {contentPart2}
                        </div>
                    }
                    button={<ConfirmButton text="Send Request" onClick={handleDeleteApproverAndClose(userDetails)} />}
                    handleCloseDialog={handleCloseDialog}
                />
            );
        }
    }
    return null;
};
